import { useState, useMemo } from 'react';
import { TABLE_CONSTANTS } from '../utils/appConstant';

interface PaginationProps {
  defaultPage: number;
  defaultPerPage?: number;
}

const usePagination = ({ defaultPerPage, defaultPage }: PaginationProps) => {
  const [page, setPage] = useState<number>(defaultPage);
  const [perPage, setPerPage] = useState<number>(defaultPerPage || TABLE_CONSTANTS.defaultPerPage);

  return useMemo(() => {
    return {
      page, perPage, setPage, setPerPage,
    };
  }, [page, perPage, setPage, setPerPage]);
};

export default usePagination;
